import React, {useCallback} from 'react';
import {Button, Typography} from 'antd';
import clsx from 'clsx';

import {getAPIBaseURL, getClientURLByEnv} from './utils';
import AgreementDialog from './AgreementDialog';

import IconLogo from '../../assets/MR_Logo_WHITE.svg';
import Logo from '../../assets/logo.svg';

import styles from './LoginHomePage.module.scss';

const LoginHomePage: React.FC = () => {
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const apiBaseURL = getAPIBaseURL();

  const handleCancel = () => {
    setOpenDialog(false);
  };

  const handleEmployeeLogin = useCallback(() => {
    // Use saved deep link or default to filter page
    const targetPath = localStorage.getItem('pendingDeepLink') || '/#/filter';
    window.location.assign(apiBaseURL + '/api/v2/auth/loginInternal?clientUrl=' + getClientURLByEnv() + targetPath);
  }, [apiBaseURL]);

  return (
    <>
      <div className={styles.wrapper}>
        <span className={clsx('noPrint', styles.header)}>
          <img src={IconLogo} alt="MR Logo" className={styles.logo} />
          <strong style={{color: 'black'}}> Model Repository </strong>
        </span>
        <div className={styles.content}>
          <img src={Logo} alt="Merck Logo" className={styles.mainLogo} />
          <Typography.Title style={{fontSize: '23px', marginBottom: '3px'}}>
            Welcome to Model Repository!
          </Typography.Title>
          <Typography.Text style={{fontSize: '18px', width: '524px', textAlign: 'center', marginBottom: '11px'}}>
            Model Repository is Merck and MSD&apos;s central place to document, access, share, and execute health
            economic models
          </Typography.Text>
          <Typography.Title level={3} style={{fontSize: '23px', margin: '0 0 18px'}}>
            Login with your existing account
          </Typography.Title>
          <Button type="primary" className={styles.button} onClick={handleEmployeeLogin}>
            I&apos;m an Employee
          </Button>

          <Button
            type="primary"
            className={styles.button}
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            I&apos;m not an Employee
          </Button>
        </div>
      </div>
      <AgreementDialog
        open={openDialog}
        title="Legal Agreement"
        apiBaseURL={apiBaseURL}
        handleCancel={handleCancel}
        LoginHomePage={true}
      />
    </>
  );
};

export default LoginHomePage;
